import "./dropdownMenu.scss";

import React, { useEffect, useRef, useState } from "react";

import { Link } from "gatsby";
import { withPrefix } from "gatsby";

interface dropdownInterface {
  items?: any[];
  dropdownTitle: string;
}

function DropdownMenu({ items, dropdownTitle }: dropdownInterface) {
  const activatorRef = useRef(null);
  const dropdownListRef = useRef(null);
  const dropdownWrapperRef = useRef(null); // Nuevo ref para el contenedor del menú
  const [isOpen, setIsOpen] = useState(false);
  const [currentSubmenu, setCurrentSubmenu] = useState(null);
  const prefixPath = withPrefix("");

  const keyHandler = (event) => {
    if (event.key === "Escape" && isOpen) {
      setIsOpen(false);
    }
  };

  const openSubMenu = (submenu) => {
    setCurrentSubmenu(submenu);
  };

  const closeSubMenu = () => {
    setCurrentSubmenu(null);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  //   const redirectClick = (clickedItem) => {
  //     if (clickedItem === "Servicios") {
  //       window.location.href = "/red-de-amor/servicios/";
  //     } else if (clickedItem === "Biblioteca") {
  //       window.location.href = "/red-de-amor/biblioteca/";
  //     }
  //   };

  const pathMap = {
    "Agendar cita": withPrefix(
      "/servicios/nutricionistas/cita-individual-de-nutrición/"
    ),
    Biblioteca: withPrefix("/biblioteca"),
    "Planes nutricionales": withPrefix("servicios/planes-nutricionales"),
    Nutricionistas: withPrefix("servicios/nutricionistas"),
  };

  const redirectClick = (clickedItem) => {
    const path = pathMap[clickedItem];
    // TODO: lógica temporal ya que el negocio NO quiere que se redireccione a nutricionistas por el momento
    if (path && !path.includes("/servicios/nutricionistas")) {
      window.location.href = path;
    }
  };

  useEffect(() => {
    if (isOpen && !!items) {
      dropdownListRef?.current.querySelector("a").focus();
    }
  }, [isOpen]);

  return (
    <div
      className={"m-dropdown__wrapper"}
      onKeyUp={keyHandler}
      onMouseLeave={closeMenu}
      ref={dropdownWrapperRef}
    >
      <button
        className={"m-dropdown__activator"}
        aria-haspopup="true"
        aria-controls={dropdownTitle}
        ref={activatorRef}
        onMouseEnter={() => setIsOpen(true)}
        onClick={() => redirectClick(dropdownTitle)}
      >
        {dropdownTitle}
        {""}
        {!!items &&
          (isOpen ? (
            <svg
              height="24"
              fill="#EE2B7C"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m0 0h24v24h-24z" fill="none" />
              <path d="m7.41 15.41 4.59-4.58 4.59 4.58 1.41-1.41-6-6-6 6z" />
            </svg>
          ) : (
            <svg
              height="24"
              fill="#EE2B7C"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m0 0h24v24h-24z" fill="none" />
              <path d="m7.41 8.59 4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
            </svg>
          ))}
        {/* {isOpen ? (
          <svg
            height="24"
            fill="#EE2B7C"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m0 0h24v24h-24z" fill="none" />
            <path d="m7.41 15.41 4.59-4.58 4.59 4.58 1.41-1.41-6-6-6 6z" />
          </svg>
        ) : (
          <svg
            height="24"
            fill="#EE2B7C"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m0 0h24v24h-24z" fill="none" />
            <path d="m7.41 8.59 4.59 4.58 4.59-4.58 1.41 1.41-6 6-6-6z" />
          </svg>
        )} */}
      </button>
      {!!items && (
        <ul
          ref={dropdownListRef}
          className={`${"m-dropdown__item-list"} ${
            isOpen || currentSubmenu ? " active" : ""
          } `}
        >
          {items?.map((item, index) => {
            return (
              <li
                className={"m-item__list"}
                key={index}
                onMouseEnter={() => openSubMenu(item.submenu)} // Abre el submenú al pasar el mouse
                onMouseLeave={closeSubMenu}
              >
                <Link to={item.slug}>{item.anchor}</Link>
                {item.submenu && currentSubmenu === item.submenu && (
                  <div className={"m-submenu__wrapper"}>
                    <ul className={"m-bg__withe"}>
                      {item.submenu.map((subitem, subindex) => (
                        <li key={subindex}>
                          <Link to={subitem.slug}>{subitem.title}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
      {/* <ul
        ref={dropdownListRef}
        className={`${"dropdown_item_list"} ${
          isOpen || currentSubmenu ? " active" : ""
        } `}
      >
        {items.map((item, index) => {
          return (
            <li
              className={"item_list"}
              key={index}
              onMouseEnter={() => openSubMenu(item.submenu)} // Abre el submenú al pasar el mouse
              onMouseLeave={closeSubMenu}
            >
              <a href={item.slug}>{item.anchor}</a>
              {item.submenu && currentSubmenu === item.submenu && (
                <div className={"submenu_wrapper"}>
                  <ul className={"bg-withe"}>
                    {item.submenu.map((subitem, subindex) => (
                      <li key={subindex}>
                        <a href={subitem.slug}>{subitem.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </li>
          );
        })}
      </ul> */}
    </div>
  );
}

export default DropdownMenu;
